// 正则表达
import * as regexp from './regexp'
// 枚举
import enumsMap from './enums'
// router各种处理
import * as routerUtil from './router'
// 权限
import limitMap from './limit'
// 轮询
import createPool from './pool'
// 如名字所说
import objectToQuery from './objectToQuery'

// 各种配置都可以丢在这里
export function throttle(method, delay) {
  let timer = null
  return (...args) => {
    const context = this
    clearTimeout(timer)
    timer = setTimeout(() => {
      method.apply(context, args)
    }, delay)
  }
}

export { regexp, enumsMap, routerUtil, limitMap, createPool, objectToQuery }

export default {}
